/* eslint-disable import/prefer-default-export */
import { gql } from '@apollo/client';

const GET_EXCEL_TEMPLATE_QUERY = gql`
  query getExcelTemplate($columns:[String]!, $descriptions: [String]){
    getExcelTemplate(columns:$columns, descriptions:$descriptions)
  }
`;
export { GET_EXCEL_TEMPLATE_QUERY };
